export default __webpack_public_path__ + "static/media/03_EGEBEFGNGTGAGJGHPU_UB150_K_right_l181107.60884ec2.jpg";